import { CAMPAIGN } from "@/lib/campaign";

const DEFAULT_ITEMS = [
  CAMPAIGN.webinarDuration,
  "5 CORE MODULES",
  "LIVE Q&A",
  "FLORIDA",
  "NO ATTENDANCE FEE",
  "EDUCATIONAL WORKSHOP",
  "WRITTEN NEXT-STEP MAP",
];

const Run = ({ items }) => (
  <div className="flex items-center shrink-0">
    {items.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="font-mono text-xs md:text-sm tracking-[0.18em] text-[rgba(255,255,255,0.75)] whitespace-nowrap px-6 py-5">
          {item}
        </span>
        <span aria-hidden="true" className="text-[var(--accent)] text-[9px]">◆</span>
      </span>
    ))}
  </div>
);

export const Ticker = ({ items = DEFAULT_ITEMS }) => (
  <section aria-label="Workshop details ticker" className="hairline-t hairline-b overflow-hidden" data-testid="info-ticker">
    <div className="ticker-track">
      <Run items={items} />
      <Run items={items} />
    </div>
  </section>
);
